import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import { utilHelper } from '../../helpers';
import { alertActions } from '../../modules/alert';

import Checkbox from '@material-ui/core/Checkbox';
import { MoreVert } from '@material-ui/icons';

const COLORS = ['#2c4bff', '#e3396d', '#e39b39', '#797979']; // normal, stop, expired, connect_n

class OpbItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nowDate: props.nowDate,
            open: false,
        }
    }

    handleSelectedOpb = (mode) => {
        // (mode === "template") 템플릿설정 팝업으로 이동
        // (mode === "floors") 층설정 팝업으로 이동
        // (mode === "content") 컨텐츠설정 팝업으로 이동
        // (mode === "opb") 기본정보 팝업으로 이동
        const { opbID, opbStatus, connectYN } = this.props.opbInfo;

        if (opbStatus !== "" && connectYN === "Y") this.props.handleSelectedOpb(opbID, mode);
        else this.props.errorAlerts("Display연결이 끊겼습니다. 확인 후 이용해주세요.");
    };

    getStatusComment = (opbStatus) => {
        let statusComment = "";

        if (opbStatus === "normal") {
            if (this.props.opbInfo.connectLastDate) {
                const connectLastDate = utilHelper.dateFromMysqlDateTime(this.props.opbInfo.connectLastDate);
                const arrPastTime = utilHelper.dhm(this.state.nowDate.getTime() - connectLastDate.getTime()).split(':');
                const pastDays = parseInt(arrPastTime[0]) > 0 ? parseInt(arrPastTime[0]) + "일 " : "";
                const pastTimes = parseInt(arrPastTime[1]) > 0 ? parseInt(arrPastTime[1]) + "시간 " : "";
                const pastMinutes = parseInt(arrPastTime[2]) >= 0 ? parseInt(arrPastTime[2]) + "분 " : "";
                statusComment = pastDays + " " + pastTimes + " " + pastMinutes + " 전 연결 상태 확인";
            }
        }
        else if (opbStatus === "stop") statusComment = "서비스 중단";
        else if (opbStatus === "expired") statusComment = "서비스 만료";
        else if (opbStatus === "connect_n") statusComment = "연결 끊김";

        return statusComment;
    };

    handleCheckedOpb = () => {
        const { opbInfo, active } = this.props;
        this.props.handleCheckedOpb(opbInfo, !active);
    };

    render() {
        const { opbInfo, active } = this.props;
        let statusValue = "";
        let colorIndex = "";

        switch (opbInfo.opbStatus) {
            case "ST001":
                statusValue = opbInfo.connectYN === "N" ? "connect_n" : "normal";
                colorIndex = opbInfo.connectYN === "N" ? 3 : 0;
                break;

            case "ST002":
                statusValue = "stop";
                colorIndex = 1;
                break;

            case "ST003":
                statusValue = "expired";
                colorIndex = 2;
                break;

            default:
                break;
        }

        return (
            <>
                <Col lg={3} md={4} sm={6} xs={12} aria-controls="simple-menu" aria-haspopup="true">
                    <div className="opbstate-opbitem">
                        <div className="opbstate-checkbox">
                            <Checkbox
                                value={this.props.opbInfo}
                                style={{ color: COLORS[colorIndex] }}
                                checked={active}
                                onChange={this.handleCheckedOpb}
                                indeterminate={opbInfo.opbStatus !== "ST001"}
                                disabled={opbInfo.opbStatus !== "ST001"}
                            />
                            <MoreVert style={{ color: COLORS[colorIndex], cursor: "pointer" }} onClick={() => this.handleSelectedOpb("opb")} />
                        </div>
                        <div className="opbstate-opbname" style={{ color: COLORS[colorIndex] }}>{utilHelper.getCodeName(opbInfo.slotCode)}</div>
                        <div className="opbstate-opbname" style={{ color: COLORS[colorIndex] }}>{this.props.opbInfo.opbNo}호기</div>
                        <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
                        <div className="text-align-center" >{this.getStatusComment(statusValue)}</div>
                    </div>
                </Col>
            </>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbItem);